import angular from 'angular';
import './call-frames-connection.scss';
import template from './call-frames-connection.html';
import { ConnectionLevel } from '../../../../modules/call/constants';
class CallFramesConnectionController {
    constructor() {
        this.items = [
            {
                level: ConnectionLevel.Excellent,
                icon: '#connection-4',
            },
            {
                level: ConnectionLevel.Fair,
                icon: '#connection-3',
            },
            {
                level: ConnectionLevel.Unstable,
                icon: '#connection-2',
            },
            {
                level: ConnectionLevel.Poor,
                icon: '#connection-1',
            },
            {
                level: ConnectionLevel.Disconnected,
                icon: '#connection-0',
            },
        ];
    }
}
const callFramesConnectionComponent = {
    template,
    bindings: {
        connection: '<',
    },
    controller: CallFramesConnectionController,
};
export default angular
    .module('doxy.videoChat.callFrames.callFramesConnection', [])
    .component('callFramesConnection', callFramesConnectionComponent).name;
